"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var verticalMenu = function (props) {
    var className = props.className, links = props.links;
    var b = config_1.block("vertical_menu");
    return (react_1.default.createElement("div", { className: b({}).mix(className) },
        react_1.default.createElement("ul", { className: b("list") }, links.map(function (link, index) { return (react_1.default.createElement("li", { key: "link-" + index, className: b("item") }, link)); }))));
};
exports.default = verticalMenu;
//# sourceMappingURL=index.js.map